import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import CloseIcon from '@material-ui/icons/Close';
import LinkIcon from '@material-ui/icons/Link';
import UnlinkIcon from '@material-ui/icons/LinkOff';

const useStyles = makeStyles(theme => ({
    active: {
        backgroundColor: 'rgba(0, 0, 0, 0.10);',
        "&:hover" : {
            backgroundColor: 'background-color: rgba(0, 0, 0, 0.10);',
        }
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
}));

export default function Link (props) {

    const classes = useStyles();

    const { editorState, onLink } = props;

    const [ urlValue, setUrlValue ] = useState("");
    const [ linkText, setLinkText ] = useState("");
    const [ linkDialogOpen, setLinkDialogOpen ] = useState(false);

    const openLinkDialog = (e) => {

        e.preventDefault()

        const selection = editorState.getSelection();

        if (!selection.isCollapsed()) {

            const contentState = editorState.getCurrentContent();
            const startKey = editorState.getSelection().getStartKey();
            const startOffset = editorState.getSelection().getStartOffset();
            const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
            const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);

            let url = '';

            if (linkKey) url = contentState.getEntity(linkKey).getData().url;

            setUrlValue(url)
            setLinkDialogOpen(true)
        }
    }

    const confirmLink = (e) => {

        e.preventDefault();

        onLink(urlValue)

        // setShowURLInput(false)

        setLinkText('')
        setUrlValue('')
        setLinkDialogOpen(false)
      }

    const removeLink = (e) => {

        e.preventDefault()

        const selection = editorState.getSelection()

        if (!selection.isCollapsed()) {
            setEditorState(RichUtils.toggleLink(editorState, selection, null))
        }
    }

    const closeLinkDialog = () => {
        setLinkDialogOpen(false);
    }

    return (
        <>
            <ButtonGroup>
                <Tooltip title="Insert Link">
                    <Button
                        size="small"
                        onClick={openLinkDialog}
                        >
                        <LinkIcon/>
                    </Button>
                </Tooltip>
                <Tooltip title="Remove Link">
                    <Button
                        size="small"
                        onClick={removeLink}
                        >
                        <UnlinkIcon/>
                    </Button>
                </Tooltip>
            </ButtonGroup>
            <Dialog
                open={linkDialogOpen}
                onClose={closeLinkDialog}
                maxWidth="md"
                >
                <DialogTitle id="edit-link-dialog-title">
                    <span>Edit Link</span>
                    <IconButton aria-label="Cancel" className={classes.closeButton} onClick={closeLinkDialog}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        variant="outlined"
                        label="Link URL"
                        value={urlValue}
                        onChange={e => setUrlValue(e.target.value)}
                        // style={{width: '400px'}}
                        helperText="Copy the web address you would like to link and paste it here."
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={closeLinkDialog}
                        variant="contained"
                        size="small"
                    >
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={confirmLink}
                    >
                        Confirm Link
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}